// extracted by mini-css-extract-plugin
module.exports = {"header":"ExpandedRowCard_header__33Jwp","body":"ExpandedRowCard_body__3khWZ"};